export { default } from './DisclosureSignerTable';
